export default "__VITE_ASSET__487c52e8__"